import type { AxiosError, AxiosInstance, AxiosResponse, InternalAxiosRequestConfig } from 'axios'
import axios from 'axios'

import { ContentTypeEnum, HttpStatusCode } from '~#/http-enum'
import type { ResponseBody, RequestConfigExtra } from '@/types'

const instance: AxiosInstance = axios.create({
  // baseURL: `${import.meta.env.VITE_APP_BASE_API}/cop/`,
  baseURL: `${import.meta.env.VITE_APP_URL}/api/cop/`,
  timeout: 60000,
  responseType: 'json',
  headers: {
    'Content-Type': ContentTypeEnum.JSON,
    'X-App-Code': import.meta.env.VITE_CLIENT_ID,
  },
  withCredentials: true,
})
// const axiosLoading = new AxiosLoading()

async function requestHandler(
  config: InternalAxiosRequestConfig & RequestConfigExtra
): Promise<InternalAxiosRequestConfig> {
  // Attach the token to the request header
  // const { token } = useAuth()
  // if (token && config.token !== false) config.headers.set('Authorization', `Bearer ${token}`)

  // Attach the client id to the request header
  config.headers.set('X-App-Code', import.meta.env.VITE_CLIENT_ID)

  // if (config.loading)
  //     axiosLoading.addLoading()
  return config
}

function responseHandler(
  response: any
): ResponseBody<any> | AxiosResponse<any> | Promise<any> | any {
  return response.data
}

async function errorHandler(error: AxiosError): Promise<any> {
  const notification = useNotification()
  const originalRequest = error.config
  console.log('error response: ', error.response)
  if (error.response) {
    const { data, status, statusText } = error.response as AxiosResponse<ResponseBody>
    if (
      status === HttpStatusCode.UNAUTHORIZED &&
      originalRequest &&
      originalRequest.url !== '/api/auth/info' &&
      originalRequest.url !== `${import.meta.env.VITE_APP_URL}/api/auth/info`
    ) {
      const auth = useAuth()
      const res = await auth.getAuthInfo()
      if (!res || !res.accessToken) {
        await auth.logout()
        notification?.error({
          message: '401',
          description: 'Phiên đăng nhập đã hết hạn, vui lòng đăng nhập lại',
          duration: 3,
        })
        return Promise.reject(error)
      }
      if (originalRequest) return instance.request(originalRequest)
    } else if (status === HttpStatusCode.FORBIDDEN) {
      notification?.error({
        message: '403',
        description: data?.message || statusText,
        duration: 3,
      })
    } else if (status === HttpStatusCode.INTERNAL_SERVER_ERROR) {
      notification?.error({
        message: '500',
        description: data?.message || statusText,
        duration: 3,
      })
    } else {
      notification?.error({
        message: 'Thông báo',
        description: data?.message || statusText,
        duration: 3,
      })
    }
  }
  return Promise.reject(error)
}

instance.interceptors.request.use(requestHandler)

instance.interceptors.response.use(responseHandler, errorHandler)

export default instance
